import { Box, Grid, Typography } from "@material-ui/core";
import {
  BLUE_PRIMARY,
  cities,
  WHITE,
  projectsPageSize,
  GREEN_PRIMRY,
} from "../utils/const";
import ProjectImage from "../assets/img/project.jpg";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { convertNumbers } from "../utils/ConvertNumbers";
import ProjectByCityChart from "../components/projectsByCitiesChart";
import InfoIcon from "@material-ui/icons/Info";
import useCustomState from "../hooks/State";
import { useMountAPI } from "../hooks/APICall";
import Call from "../service/API";
import { useEffect } from "react";
import Loading from "../components/loading";
import Paginator from "../components/paginator"; // for pagination
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import moment from "jalali-moment";

const ProjectReports = (props) => {
  const totalStatistics = useCustomState({});
  const totalStatisticsIsLoading = useCustomState(true);

  const projectsByCityIsLoading = useCustomState(true);
  const projectsIsLoading = useCustomState(true);

  const allItems = useCustomState(0); // for pagination
  const selectedPage = useCustomState(1); // for pagination

  const projectsByCity = useCustomState({});
  const projectsByCityList = useCustomState([]);
  const projects = useCustomState([]);

  const cityWithMaxProject = useCustomState("");
  const projectWithMaxCounters = useCustomState({ name: "0", counters: 0 });

  const history = useHistory();

  const projectsByCityUtils = {
    isLoading: projectsByCityIsLoading,
    ProjectsByCity: projectsByCity,
  };

  const projectNameFilter = useCustomState("");
  const projectCreateDateFilter = useCustomState("");

  const projectsUtils = {
    page: selectedPage.value, // for pagination
    count: projectsPageSize, // for pagination
    projectNameFilter: projectNameFilter.value,
    projectCreateDateFilter: projectCreateDateFilter.value,
    isLoading: projectsIsLoading,
    projects: projects,
    allItems: allItems, // for pagination
    history: history,
  };

  const totalStatisticsUtils = {
    isLoading: totalStatisticsIsLoading,
    totalStatistics: totalStatistics,
    history: history,
  };

  useMountAPI(fetchProjectsByCity, projectsByCityUtils);
  useMountAPI(fetchProjects, projectsUtils);
  useMountAPI(fetchStatistics, totalStatisticsUtils);

  // for pagination
  const selectedPageChanged = (newPage) => {
    if (newPage !== selectedPage.value) {
      selectedPage.handleChange(newPage);
      projectsUtils.page = newPage;
      projectsIsLoading.handleChange(true);
      fetchProjects(projectsUtils);
    }
  };

  useEffect(() => {
    if (!projectsByCityIsLoading.value) {
      const cities = Object.keys(projectsByCity.value);
      let allProjects = 0;
      let cityMaxProject = "";
      let maxProject = 0;
      cities.map((city) => {
        const value = projectsByCity.value[city];
        if (value > maxProject) {
          maxProject = value;
          cityMaxProject = city;
        }
        allProjects += value;
      });
      cityWithMaxProject.handleChange(cityMaxProject);
      const projectList = [];
      cities.map((city, idx) => {
        const data = {
          city: city,
          projects: projectsByCity.value[city],
          percent: ((projectsByCity.value[city] / allProjects) * 100.0).toFixed(
            2
          ),
        };
        projectList.push(data);
      });
      projectsByCityList.handleChange(projectList);
    }
  }, [projectsByCityIsLoading.value]);

  useEffect(() => {
    if (!projectsIsLoading.value) {
      let maxC = 0;
      let p = "";
      projects.value.map((project) => {
        if (project.counters > maxC) {
          maxC = project.counters;
          p = project.name;
        }
      });
      projectWithMaxCounters.handleChange({ name: p, counters: maxC });
    }
  }, [projectsIsLoading.value]);

  const renderPaginator = () => {
    {
      /* 
            begin: for pagination
          */
    }
    return (
      <Grid item sx={12} sm={12} md={12} lg={12}>
        <Grid container>
          <Paginator
            selectedPage={selectedPage.value}
            items={allItems.value}
            pageSize={projectsPageSize}
            selectedPageChanged={selectedPageChanged}
          />
        </Grid>
      </Grid>
    );
    {
      /* end: for pagination */
    }
  };

  const renderProjectStatisticsTable = () => {
    if (totalStatisticsIsLoading.value) {
      return (
        <div style={{ position: "relative", width: "100%", height: "320px" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <TableContainer
          component={Paper}
          style={{
            width: "400px",
            maxWidth: "400px",
            marginRight: "auto",
            marginLeft: "auto",
          }}
        >
          <Table sx={{ maxWidth: 700 }} aria-label="customized table">
            <TableBody>
              <TableRow>
                <TableCell>تعداد پروژه ها</TableCell>
                <TableCell>
                  {convertNumbers(totalStatistics.value.allProjects)}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>تعداد شهرها</TableCell>
                <TableCell>
                  {convertNumbers(totalStatistics.value.allCities)}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>شهر با بیشترین تعداد پروژه</TableCell>
                <TableCell>
                  {convertNumbers(
                    totalStatistics.value.citiesWithMaxProjects.names +
                      " (" +
                      totalStatistics.value.citiesWithMaxProjects.projects +
                      ")"
                  )}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>پروژه با بیشترین تعداد کنتور</TableCell>
                <TableCell>
                  {convertNumbers(
                    totalStatistics.value.projectsWithMaxCounters.names +
                      " (" +
                      totalStatistics.value.projectsWithMaxCounters.counters +
                      ")"
                  )}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      );
    }
  };

  const renderProjectStatistics = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            marginTop: "48px",
            paddingBottom: "16px",
            marginBottom: "16px",
            borderBottom: "1px solid #333333",
          }}
        >
          <Box
            textAlign={"left"}
            style={{
              maxWidth: "400px",
              width: "400px",
              marginRight: "auto",
              marginLeft: "auto",
              marginBottom: "16px",
            }}
          >
            <Typography style={{ fontWeight: "bold" }}>آمار کلی</Typography>
          </Box>
          {renderProjectStatisticsTable()}
        </Grid>
      </>
    );
  };

  const renderTableProjectsByCities = () => {
    if (projectsByCityIsLoading.value) {
      return (
        <div style={{ position: "relative", width: "100%", height: "320px" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <TableContainer component={Paper}>
          <Table sx={{ maxWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <TableCell align={"center"}>#</TableCell>
                <TableCell align={"center"}>شهر</TableCell>
                <TableCell align={"center"}>تعداد پروژه</TableCell>
                <TableCell align={"center"}>تعداد پروژه (%)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {projectsByCityList.value.map((project, idx) => {
                return (
                  <TableRow key={idx}>
                    <TableCell align={"center"}>
                      {convertNumbers(idx + 1)}
                    </TableCell>
                    <TableCell align={"center"}>{project.city}</TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(project.projects)}
                    </TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(project.percent + "%")}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      );
    }
  };

  const renderChartProjectsByCity = () => {
    if (projectsByCityIsLoading.value) {
      return (
        <div style={{ position: "relative", width: "100%", height: "320px" }}>
          <Loading />
        </div>
      );
    } else {
      return <ProjectByCityChart projectsByCity={projectsByCity.value} />;
    }
  };

  const renderProjectsByCities = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{ marginBottom: "16px" }}
        >
          <Typography style={{ fontWeight: "bold" }}>
            آمار پروژه ها به تفکیک شهرها
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={5}
          style={{
            borderBottom: "1px solid #333333",
            height: "380px",
            overflow: "scroll",
          }}
        >
          {renderTableProjectsByCities()}
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={7}
          style={{
            borderBottom: "1px solid #333333",
            height: "380px",
            overflow: "scroll",
          }}
        >
          {renderChartProjectsByCity()}
        </Grid>
      </>
    );
  };

  const renderProjectDetailsTable = () => {
    if (projectsIsLoading.value) {
      return (
        <div style={{ position: "relative", width: "100%", height: "260px" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <TableContainer
          component={Paper}
          style={{
            marginRight: "auto",
            marginLeft: "auto",
          }}
        >
          <Table sx={{ maxWidth: 700 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <TableCell align={"center"}>#</TableCell>
                <TableCell align={"center"}>نام پروژه</TableCell>
                <TableCell align={"center"}>شهر</TableCell>
                <TableCell align={"center"}>تاریخ شروع</TableCell>
                <TableCell align={"center"}>تعداد کاربر</TableCell>
                <TableCell align={"center"}>تعدا نوع کنتور</TableCell>
                <TableCell align={"center"}>تعدا کنتور</TableCell>
                <TableCell align={"center"}>جزئیات</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {projects.value.map((project, idx) => {
                return (
                  <TableRow>
                    <TableCell align={"center"}>
                      {convertNumbers(
                        (selectedPage.value - 1) * projectsPageSize + idx + 1
                      )}
                    </TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(project.name)}
                    </TableCell>
                    <TableCell align={"center"}>{project.location}</TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(
                        moment(project.date).locale("fa").format("YYYY/MM/DD")
                      )}
                    </TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(project.users)}
                    </TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(project.types)}
                    </TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(project.counters)}
                    </TableCell>
                    <TableCell align={"center"}>
                      <Link to={"/admin/project-dash/" + project.id}>
                        <InfoIcon
                          style={{
                            color: BLUE_PRIMARY,
                            fontSize: "24px",
                            cursor: "pointer",
                          }}
                        />
                      </Link>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      );
    }
  };

  const renderProjectDetails = () => {
    return (
      <>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            marginTop: "24px",
            paddingBottom: "16px",
            marginBottom: "16px",
            borderBottom: "1px solid #333333",
          }}
        >
          <Box
            textAlign={"left"}
            style={{
              marginRight: "auto",
              marginLeft: "auto",
              marginBottom: "16px",
            }}
          >
            <Typography style={{ fontWeight: "bold" }}>
              جزئیات آمار پروژه ها
            </Typography>
          </Box>
          {renderProjectDetailsTable()}
          {renderPaginator()}
        </Grid>
      </>
    );
  };

  return (
    <Grid
      container
      style={{
        marginTop: "64px",
        paddingTop: "16px",
        paddingBottom: "16px",
        paddingRight: "8px",
        paddingLeft: "8px",
      }}
    >
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{
          backgroundColor: WHITE,
          paddingRight: "16px",
          paddingLeft: "16px",
          paddingTop: "24px",
          paddingBottom: "24px",
          borderRadius: "8px",
          position: "relative",
        }}
      >
        {/* <img
          src={ProjectImage}
          width={100}
          height={100}
          style={{
            borderRadius: "50%",
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            top: "-60px",
          }}
        /> */}
        <Box
          style={{
            maxWidth: "250px",
            // border: "1px solid red",
            marginRight: "auto",
            marginLeft: "auto",
            marginTop: "-60px",
            paddingRight: "36px",
            paddingLeft: "36px",
            paddingTop: "24px",
            paddingBottom: "24px",
            borderRadius: "12px",
            backgroundColor: GREEN_PRIMRY,
            color: WHITE,
            cursor: "pointer",
          }}
          textAlign={"center"}
        >
          <Typography style={{ fontWeight: "bold" }}>گزارش پروژه ها</Typography>
        </Box>
        <Grid container>
          {renderProjectStatistics()}
          {renderProjectsByCities()}
          {renderProjectDetails()}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ProjectReports;

const fetchProjectsByCity = (utils) => {
  const isLoading = utils.isLoading;
  const projectsByCity = utils.ProjectsByCity;

  Call("GET", "WaterMeterProjectsURL/admin/getAll/city/count", null)
    .then((response) => {
      // console.log("projectsByCity", response);
      if (response.data.code == 200) {
        projectsByCity.handleChange(response.data.data);
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.respone) {
        const data = error.response.data;
        // console.log(data);
      }
      isLoading.handleChange(false);
    });
};

const processProjects = (projects) => {
  const results = [];
  let data, date;
  projects.map((project) => {
    date = project.water_meter_project_start_date;
    data = {
      name: project.water_meter_project_name,
      user: "",
      location: project.water_meter_project_title,
      date: date,
      counters: project.water_meters_with_this_id.All_water_meter_with_this_id,
      id: project.water_meter_project_id,
      types: project.types.length,
      users: project.all_users_in_project,
    };
    results.push(data);
  });
  return results;
};

const fetchProjects = (utils) => {
  const page = utils.page;
  const count = utils.count;
  const projectNameFilter = utils.projectNameFilter;
  const projectCreateDateFilter = utils.projectCreateDateFilter;
  const isLoading = utils.isLoading;
  const projects = utils.projects;
  const allItems = utils.allItems; // for pagination
  const history = utils.history;

  const data = {
    page: page,
    count: count,
    water_meter_project_name: projectNameFilter,
    water_meter_project_create_date: projectCreateDateFilter,
  };
  Call("POST", "WaterMeterProjectsURL/admin/getAll", data)
    .then((response) => {
      // console.log("projects", response);
      if (response.data.code == 200) {
        const ps = response.data.data;
        /* begin: for pagination */
        if (ps && ps.length !== 0) {
          allItems.handleChange(ps[0]["all projects"]);
        }
        /* end: for pagination */
        projects.handleChange(processProjects(ps));
        isLoading.handleChange(false);
      }
    })
    .catch((error) => {
      // console.log(error);
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
        if (data.code === 403) {
          history.push("/admin/login");
        }
      }
      isLoading.handleChange(false);
    });
};

const processStatistics = (statistics) => {
  let cities = "";
  let numProjects = 0;
  statistics.city_with_max_projects.map((city, idx) => {
    if (idx === 0) {
      cities += city[0];
      numProjects = city[1];
    } else {
      cities += "-" + city[0];
    }
  });
  let projects = "";
  let numCounters = 0;
  statistics.project_with_max_counters.map((project, idx) => {
    if (idx === 0) {
      projects += project.water_meter_project_name;
      numCounters = project.number_of_counter;
    } else {
      projects += "-" + project.water_meter_project_name;
    }
  });

  const processedStatistics = {
    allProjects: statistics.all_projects,
    allCities: statistics.all_cities,
    citiesWithMaxProjects: {
      names: cities,
      projects: numProjects,
    },
    projectsWithMaxCounters: {
      names: projects,
      counters: numCounters,
    },
  };

  // console.log(processedStatistics);

  return processedStatistics;
};

const fetchStatistics = (utils) => {
  const isLoading = utils.isLoading;
  const totalStatistics = utils.totalStatistics;
  const history = utils.history;

  Call("POST", "WaterMeterProjectsURL/admin/total/statistics", null)
    .then((response) => {
      // console.log("total statistics: ", response);
      if (response.data.code === 200) {
        totalStatistics.handleChange(processStatistics(response.data.data));
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      // console.log(error);
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
        if (data.code === 403) {
          history.push("/admin/login");
        }
      }
      isLoading.handleChange(false);
    });
};
